// extracted by mini-css-extract-plugin
export default {"container":"SimpleButton_container__VVFsg","spinner":"SimpleButton_spinner__njwEb"};